<template>
  <el-dialog
    title="批量导入订单"
    :visible.sync="innerVisible"
    width="560px"
    center
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <p class="tip">
      请下载模板按列填写后上传，支持 .xlsx、.xls、.csv；单次导入多条，无需逐条提交。
    </p>
<!--    <div class="template-row">-->
<!--      <el-button type="text" icon="el-icon-download" :loading="templateLoading" @click="downloadTemplate">-->
<!--        下载导入模板-->
<!--      </el-button>-->
<!--    </div>-->
    <el-upload
      ref="upload"
      class="upload-block"
      drag
      action="#"
      :limit="1"
      :auto-upload="false"
      :file-list="fileList"
      :on-change="handleFileChange"
      :http-request="handleImport"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      accept=".xlsx,.xls,.csv"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将表格拖到此处，或<em>点击选择</em></div>
      <div slot="tip" class="el-upload__tip">仅支持 Excel / CSV，大小不超过 10MB</div>
    </el-upload>
    <p class="columns-hint">
      模板列说明（须与后端解析一致）：患者姓名、手机号、身份证号、地址、失能类型（1 失能 / 2 半失能）、护理站（名称或 ID，多站用英文逗号分隔）。
    </p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">关 闭</el-button>
      <el-button type="primary" :loading="uploading" :disabled="!fileList.length" @click="startImport">
        开始导入
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fetchOrdersSnImportTemplate, importOrdersTf } from '@/api'

export default {
  name: 'CreateOrderDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerVisible: false,
      uploading: false,
      templateLoading: false,
      fileList: []
    }
  },
  watch: {
    visible(v) {
      this.innerVisible = v
      if (v) {
        this.reset()
      }
    },
    innerVisible(v) {
      if (!v) this.$emit('update:visible', false)
    }
  },
  methods: {
    reset() {
      this.fileList = []
      this.uploading = false
      this.$nextTick(() => {
        if (this.$refs.upload) {
          this.$refs.upload.clearFiles()
        }
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList
    },
    beforeUpload(file) {
      const name = (file.name || '').toLowerCase()
      const ok = /\.(xlsx|xls|csv)$/.test(name)
      const max = 10 * 1024 * 1024
      if (!ok) {
        this.$message.warning('请上传 .xlsx、.xls 或 .csv 文件')
        return false
      }
      if (file.size > max) {
        this.$message.warning('文件大小不能超过 10MB')
        return false
      }
      return true
    },
    handleExceed() {
      this.$message.warning('请先移除已选文件，每次仅可上传一个表格')
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    /** 导入 body[region]：会话 storage 中 tk_area 数组第一项（登录写入 JSON.stringify） */
    getImportRegionFromSession() {
      try {
        const raw = sessionStorage.getItem('tk_area')
        if (!raw) return ''
        const arr = JSON.parse(raw)
        if (!Array.isArray(arr) || !arr.length) return ''
        const first = arr[0]
        if (first == null) return ''
        if (typeof first === 'object') {
          const v = first.id != null ? first.id : first.name != null ? first.name : ''
          return v === '' || v == null ? '' : String(v).trim()
        }
        return String(first).trim()
      } catch (e) {
        return ''
      }
    },
    handleImport(options) {
      const region = this.getImportRegionFromSession()
      const fd = new FormData()
      fd.append('file', options.file)
      fd.append('body[region]', region)
      this.uploading = true
      importOrdersTf(fd)
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || '导入成功')
            this.reset()
            this.innerVisible = false
            this.$emit('success')
          } else {
            this.$message.warning(res.msg || '导入失败')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.uploading = false
        })
    },
    startImport() {
      if (!this.$refs.upload) return
      if (!this.fileList.length) {
        this.$message.warning('请先选择要导入的表格文件')
        return
      }
      const region = this.getImportRegionFromSession()
      if (!region) {
        this.$message.warning('未获取到护理站权限（会话中 tk_area 为空），请重新登录后重试')
        return
      }
      this.$refs.upload.submit()
    },
    downloadTemplate() {
      this.templateLoading = true
      fetchOrdersSnImportTemplate()
        .then(res => {
          if (res.status && res.data) {
            const elink = document.createElement('a')
            elink.href = res.data
            elink.download = '新项目订单导入模板.xlsx'
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          } else {
            this.$message.warning(res.msg || '暂无模板，请按页面说明自建 Excel 后上传')
          }
        })
        .finally(() => {
          this.templateLoading = false
        })
    }
  }
}
</script>

<style scoped>
.tip {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin: 0 0 8px;
}
.template-row {
  margin-bottom: 12px;
}
.upload-block {
  width: 100%;
}
.upload-block >>> .el-upload {
  width: 100%;
}
.upload-block >>> .el-upload-dragger {
  width: 100%;
}
.columns-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin: 12px 0 0;
}
</style>
